// PRD 13 §4.1 — author/publisher cell.
// Format: Name + [Role Badge] + Email (e.g. 강현우 [ROOT] hw.kang@carelink.co.kr).

import type { NoticeAuthor } from '../types/notices.types';

interface NoticeAuthorCellProps {
  author: NoticeAuthor;
}

export function NoticeAuthorCell({ author }: NoticeAuthorCellProps) {
  return (
    <div style={{ lineHeight: 1.4 }} title={`${author.name} (${author.authorGrade}) ${author.email}`}>
      <span style={{ fontWeight: 600 }}>{author.name}</span>{' '}
      <span className="badge badge-outline" style={{ fontSize: 10, padding: '2px 6px' }}>
        {author.authorGrade}
      </span>
      <br />
      {/* Email truncates to the column width; the full value is in the cell tooltip. */}
      <span className="text-ellipsis" style={{ display: 'block', color: 'var(--muted-foreground)', fontSize: 12 }}>
        {author.email}
      </span>
    </div>
  );
}
